import axios from 'axios';
import store from '@/store';
import router from '@/router';

axios.interceptors.request.use(
  (config) => {
    const newConfig = { ...config };
    if (store.state.AuthStore.JWTToken) {
      newConfig.headers.Authorization = `Bearer ${store.state.AuthStore.JWTToken}`;
    }
    return newConfig;
  },
  error => Promise.reject(error),
);

axios.interceptors.response.use(response => Promise.resolve(response), (error) => {
  // unauthorized
  if (error.response.status === 401) {
    sessionStorage.clear();
    store.dispatch('AuthStore/logout');
    router.push({ name: 'login' });
  }

  return Promise.reject(error);
});

export default axios;
